var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShortcutMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "3.25 2.25 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__more_horiz-24px",
    transform: "rotate(90 23 23)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_452",
    fill: "none",
    d: "M0 0h46v46H0z",
    "data-name": "Path 452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_453",
    fill: "#222",
    d: "M7.833 10a3.833 3.833 0 1 0 3.833 3.833A3.845 3.845 0 0 0 7.833 10zm23 0a3.833 3.833 0 1 0 3.833 3.833A3.845 3.845 0 0 0 30.833 10zm-11.5 0a3.833 3.833 0 1 0 3.833 3.833A3.845 3.845 0 0 0 19.333 10z",
    "data-name": "Path 453",
    transform: "translate(3.667 9.167)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShortcutMenu);
export default __webpack_public_path__ + "static/media/shortcutMenu.ab05a80d.svg";
export { ForwardRef as ReactComponent };